// eslint-disable-next-line no-redeclare,import/export
export enum TicketChannelOption {
  SMS = 'sms',
  LIVE_CHAT = 'live_chat',
  WHATSAPP = 'whatsapp',
}

const values = Object.values(TicketChannelOption);

// eslint-disable-next-line no-redeclare,import/export
export namespace TicketChannelOption {
  export function mapValues(callbackFn: Parameters<Array<TicketChannelOption>['map']>[0]) {
    return values.map(callbackFn);
  }

  export const human = Object.freeze({
    [TicketChannelOption.SMS]: 'SMS',
    [TicketChannelOption.LIVE_CHAT]: 'Live Chat',
    [TicketChannelOption.WHATSAPP]: 'WhatsApp',
  });
}
